import { render, staticRenderFns } from "./ColorsPipMenu.vue?vue&type=template&id=549ae6a0&scoped=true"
import script from "./ColorsPipMenu.vue?vue&type=script&lang=js"
export * from "./ColorsPipMenu.vue?vue&type=script&lang=js"
import style0 from "./ColorsPipMenu.vue?vue&type=style&index=0&id=549ae6a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549ae6a0",
  null
  
)

export default component.exports